export default __webpack_public_path__ + "static/media/benefit-4.a5ccb270.svg";